import { useEffect, useState, type JSX } from 'react'
import { staffApi, type StaffProfFeedbackRow } from '../../api/staff'
import { useTokens } from '../../state/theme'

export default function ProfFeedbackQueueScreen(): JSX.Element {
  const tokens = useTokens()
  const [rows, setRows] = useState<StaffProfFeedbackRow[] | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let alive = true
    staffApi.listProfFeedback('confusing')
      .then(({ feedback }) => { if (alive) setRows(feedback) })
      .catch(() => { if (alive) setFailed(true) })
    return () => { alive = false }
  }, [])

  return (
    <section style={{ padding: 28, color: tokens.text, fontFamily: tokens.fonts.body, maxWidth: 900 }}>
      <h1 style={{ margin: 0, fontFamily: tokens.fonts.serif, fontSize: 28 }}>Risposte da rivedere</h1>
      <p style={{ color: tokens.textMuted, marginTop: 8 }}>
        Segnalazioni degli studenti. Il feedback non modifica automaticamente Progressi o il modello.
      </p>
      {failed ? <p role="alert">Non è stato possibile caricare le segnalazioni.</p> : null}
      {!failed && rows === null ? <p>Caricamento…</p> : null}
      {!failed && rows?.length === 0 ? <p>Nessuna risposta segnalata come non chiara.</p> : null}
      <div style={{ display: 'grid', gap: 14 }}>
        {rows?.map((row) => (
          <article key={row.message_id} style={{ background: tokens.surface, border: `1px solid ${tokens.line}`, borderRadius: 16, padding: 18 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, color: tokens.textMuted, fontSize: 13 }}>
              <strong style={{ color: tokens.text }}>{row.student_first_name}</strong>
              <time dateTime={row.updated_at}>{new Date(row.updated_at).toLocaleString('it-IT')}</time>
            </div>
            <p style={{ whiteSpace: 'pre-wrap', lineHeight: 1.55, margin: '14px 0' }}>{row.response_text}</p>
            <div style={{ color: tokens.textFaint, fontSize: 12 }}>
              {row.engine} · {row.model_id} · {row.pack_id ?? 'nessun pack'} · guardrail {row.guardrail_outcome}
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
